var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { Role } from '../../roles/index.js';
import { HubSpotQuestionType } from '../enums/hubspot-question-type.enum.js';
import { HubSpotQuestionOptionResponseDto } from './hubspot-question-option.response.dto.js';
/**
 * Response DTO for HubSpotQuestion.
 * Used for API responses (query operations).
 */
export class HubSpotQuestionResponseDto {
    id;
    createdAt;
    updatedAt;
    hubspotPropertyInternalName;
    waitDaysAfterRegistration;
    question;
    questionType;
    options;
    visibleForRoles;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], HubSpotQuestionResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], HubSpotQuestionResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionResponseDto.prototype, "hubspotPropertyInternalName", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], HubSpotQuestionResponseDto.prototype, "waitDaysAfterRegistration", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionResponseDto.prototype, "question", void 0);
__decorate([
    IsEnum(HubSpotQuestionType),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionResponseDto.prototype, "questionType", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => HubSpotQuestionOptionResponseDto),
    Expose(),
    __metadata("design:type", Array)
], HubSpotQuestionResponseDto.prototype, "options", void 0);
__decorate([
    IsArray(),
    IsEnum(Role, { each: true }),
    Expose(),
    __metadata("design:type", Array)
], HubSpotQuestionResponseDto.prototype, "visibleForRoles", void 0);
//# sourceMappingURL=hubspot-question.response.dto.js.map